/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol, HtmlParser } from 'sarsaparilla';
import get from 'lodash/get';
import SmartSelector from './SmartSelector';
import {
    getValidationErrorStyle,
    isPermitPickUp,
    readRuleValue,
    readRuleMetadata,
} from '../../utils/utilsNew';
import * as types from '../../constants';

export default class IssueStationDetail extends React.Component {
    static propTypes = {
        issueStationDetail: PropTypes.shape({
            selectedStationId: PropTypes.string,
        }),
        handleIssueStationDetailChange: PropTypes.func,
        validation: PropTypes.shape({}),
        issueStations: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        rules: PropTypes.array,
    };

    static defaultProps = {
        issueStationDetail: {},
        issueStations: [],
    };

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const newDetail = this.props.issueStationDetail;
        newDetail.selectedStationId = event.target.value;
        this.props.handleIssueStationDetailChange(newDetail);
    }

    renderSingleIssueStation() {
        return (
            <div className="per-issue-station-form per-section-group">
                <div className="rec-order-detail-subsection-title">Issuing Station</div>
                <p>
                    You will be required to pick up your permit in person at the below
                    location. Your confirmation email will have further instructions.
                </p>
                <FlexRow>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <label htmlFor="issue-station">Station Location</label>
                            <span className="per-static-form-item" id="issue-station">
                                {this.props.issueStations[0].name}
                            </span>
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }

    renderPermitPickupOption() {
        const validationHighlight = getValidationErrorStyle(
            this.props.validation,
            types.IS_ISSUE_STATION_EMPTY
        );
        const printText =
            'Please select from the locations below where you will be picking up your permit.';
        const specialIssuingText = readRuleMetadata(
            types.SPECIAL_PRINTING_TEXT,
            this.props.rules,
            ''
        ); // Printing and issuing can't be co-rendered, so re-using print rule
        return (
            <div className="per-issue-station-form per-section-group">
                <div className="rec-order-detail-subsection-title">Issuing Station</div>
                <p>
                    {specialIssuingText ? (
                        <p>
                            <HtmlParser html={specialIssuingText} />
                        </p>
                    ) : (
                        <p>{printText}</p>
                    )}
                </p>
                <FlexRow>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <SmartSelector
                                label="Station Location"
                                options={this.props.issueStations.map((a) => ({
                                    value: a.id,
                                    label: a.name,
                                }))}
                                name="issue-station"
                                id="issue-station"
                                isRequired
                                value={this.props.issueStationDetail.selectedStationId}
                                handleChange={this.handleChange}
                                className={validationHighlight}
                                validationError={
                                    this.props.validation.displayValidationError &&
                                    !this.props.issueStationDetail.selectedStationId
                                }
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }

    renderPermitPrintingOption() {
        const printWindow = readRuleValue(types.ONLINE_PRINTING, this.props.rules, '');
        const specialPrintText = readRuleMetadata(
            types.SPECIAL_PRINTING_TEXT,
            this.props.rules,
            ''
        );
        if (!printWindow && !specialPrintText) {
            return null;
        }
        const printText = `You are required to print the permit before going on this trip.
          You will be able to print your permit starting ${printWindow} days before your launch date.`;
        return (
            <div className="per-issue-station-form per-section-group">
                <div className="rec-order-detail-subsection-title">Permit Printing</div>
                <div className="per-printing-content">
                    {specialPrintText ? (
                        <p>
                            <HtmlParser html={specialPrintText} />
                        </p>
                    ) : (
                        <p>{printText}</p>
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (isPermitPickUp(this.props.issueStations)) {
            if (get(this.props.issueStations, 'length', 0) === 1) {
                return this.renderSingleIssueStation();
            }
            return this.renderPermitPickupOption();
        }
        return this.renderPermitPrintingOption();
    }
}
